import { render, staticRenderFns } from "./LibraryIcon.vue?vue&type=template&id=7bc8183c&scoped=true"
import script from "./LibraryIcon.vue?vue&type=script&lang=js"
export * from "./LibraryIcon.vue?vue&type=script&lang=js"
import style0 from "./LibraryIcon.vue?vue&type=style&index=0&id=7bc8183c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8183c",
  null
  
)

export default component.exports